import React from 'react'

function NewNews(props) {
    return (
        <article className={`side-news-new-article ${props.first ? 'side-news-no-border' : ""}`}>
            <a href="/" className='side-news-aside-title'>{props.title}</a>
            <p className='side-news-content' tabIndex={0}>{props.content}</p>
        </article>
    );
}
const SideNews = () => {
    return (
        <aside className="side-news">
            {/* Side news section - beside Main news */}
            <h2 className="side-news-title">News</h2>
            <NewNews
                title="Hydrogen VS Electric Cars"
                content="Will hydrogen-fueled cars ever catch up to EVs?"
                first={true}
            />
            <NewNews
                title='The Downsides of AI Artistry'
                content='What are the possible adverse effects of on-demand AI image generation?'
            />
            <NewNews
                title='Is VC Funding Drying Up?'
                content='Private funding by VS firms is down 50% YOY. We take a look at what that means.'
            />
        </aside>
    )
}

export default SideNews